<template>
  <a-select
    filterable
    v-model="currentValue">
    <a-select-option
      v-for="item in options"
      :key="item.id"
      :title="`${item.name}     [ ${item.code} ]`"
      :value="item.id">
      <span style="float: left">{{ item.name }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.code }}</span>
    </a-select-option>
  </a-select>
</template>

<script>
import { _queryGoods } from '@/api/goodsApi';

export default {
  name: 'GoodsSelect',
  props: {
    dictCode: String,
    value: String,
  },
  data() {
    return {
      form: {
        visible: false,
        data: {
          name: '',
        },
      },
      table: {
        data: [],
      },
      options: [],
      currentValue: this.value,
      currentGoodsName: '',
    };
  },
  watch: {
    currentValue(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.currentValue = val;
    },
  },
  methods: {
    choiceGoods(item) {
      this.$emit('input', item.id);
      this.currentGoodsName = item.name;
      this.form.visible = false;
    },
    openSearchForm() {
      this.form.visible = true;
      this.form.data.name = '';
    },
    onValueChange() {
    },
    async searchGoods() {
      if (this.form.data.name) {
        const result = await _queryGoods({ name: this.form.data.name });
        this.table.data = result.content;
      }
    },
  },
  async created() {
    const result = await _queryGoods({ name: this.form.data.name });
    this.options = result.content;
  },
};
</script>

<style scoped>
  .goods-wrap {
    height: 400px;
    overflow-y: auto;
  }

  .goods-item {
    margin: 10px 5px;
    cursor: pointer;
  }

  .goods-item:hover {
    color: #00A8CC;
  }

</style>
